import React from 'react'

import Header from '@zet/common/components/header'
import { Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'

import { usePaymentDetails } from '../../api/paymentModes/hooks'
import EditButton from './editButton'
import PaymentDetails from './paymentDetails'

const EditBankAccountDetails = () => {
  const { data: paymentDetails } = usePaymentDetails()
  return (
    <Stack>
      <Header
        title={i18n.t('addBankAccount.accountDetails')}
        showBackIcon
        headerRightButton={<EditButton />}
      />
      <PaymentDetails paymentDetails={paymentDetails || {}} />
    </Stack>
  )
}

export default EditBankAccountDetails
